export const autoBuster = 'auto-buster';
export const heater = 'heater';
export const miniTank = 'miniTank';
export const tankless = 'tankless';
export const needHelp = 'need-help';
export const callUs = 'call-us';

const branch120 = '120';
const branchWholeHome = 'whole-home';
const branchAutoBuster = 'auto-buster';
const branchSingleFixture = 'single-fixture';
const branchTwoFixture = 'two-fixture';
const branchSolar = 'solar';
const branchFaster = 'faster';

const stepMap = 'map';
const stepSelectBranch = 'select-branch';
const stepGoalTemp = 'goal-temp';
const stepFlowRate = 'flow-rate';
export const stepHeaterChoise = 'heater-choose';
export const stepMiniTankChoise = 'mini-tank-choose';

export default [
  {
    id: stepMap,
    step: 'Map',
    component: 'Map',
    nextId: stepSelectBranch,
    prevId: null,
    paramName: 'temp-in',
  },
  {
    id: stepSelectBranch,
    step: 'Application Detail',
    component: 'Selector',
    title: 'Please choose your application detail:',
    tip: '<b>Note</b>: The fixtures selected in the following pages should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    options: [
      { title: 'New construction or replacement whole home water heating solution', value: '1', nextId: branchWholeHome },
      {
        title: 'Increase hot water from our existing tank',
        params: { 'product-family': ['574f0840-90e3-4f1b-9809-53024467eb69'] },
        value: '2',
        nextId: branchAutoBuster,
      },
      {
        title: 'I need hot water for a single fixture', params: { phase: 1 }, value: '3', nextId: branchSingleFixture,
      },
      { title: 'Decrease water waste & need hot water faster', value: '4', nextId: branchFaster },
      {
        title: 'I need a 120V solution for hot water',
        params: { volts: 120 },
        value: '5',
        nextId: branch120,
        hint: 'Hot water from 120V is only satisfactory for low flow/low demand handwashing applications i.e. outdoor kitchens, barns, workshops, RV’s, pleasure boats, & food trucks. When hot water demand is greater than handwashing, the heat provided is very limited.',
      },
      { title: 'I need hot water for 2 or more handwashing fixtures', value: '6', nextId: branchTwoFixture },
      { title: 'I need a solar thermal backup', value: '7', nextId: branchSolar },
    ],
  },
  {
    id: branchWholeHome,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    tip: '<b>Note</b>: For Whole Home use, there is no 120V heater that would suffice. It would have to be 240V preferably, or 208V.',
    hint: 'Almost all residential homes will have 240 volts as a standard ‘high’ voltage.  This is the voltage that powers your electric tank-type hot water heater, electric range, electric clothes dryer, well pump, central air conditioning system, and other high-power devices in your home. However, there are some areas of the country (Metro New York City, for example) where 208 VAC is the standard ‘high’ voltage available. In addition, 208 VAC is sometimes found as the ‘high’ voltage in apartment buildings, condominiums, factory building loft conversions, and the like.  If you are unsure of your ‘high’ voltage in your residence, call an electrician, your local electrical utility, a building maintenance employee or building supervisor for more information',
    options: [
      {
        title: '208 V', value: '208 V', params: { 'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'], volts: 208, phase: 1 }, nextId: `${branchWholeHome}_${stepGoalTemp}`,
      },
      {
        title: '240 V', value: '240 V', params: { 'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'] }, nextId: `${branchWholeHome}_${stepGoalTemp}`,
      },
    ],
  },
  {
    id: `${branchWholeHome}_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    tip: '<b>Note</b>: According to the Consumer Protection Safety Commission: Most adults can suffer 3rd-degree burns if exposed to 140°F water within 6 seconds. Burns can also occur within 30 seconds @ 130°F, & 5 minutes @ 120°F.',
    paramName: 'temp-out',
    nextId: stepHeaterChoise,
  },
  {
    id: stepHeaterChoise,
    step: 'Heater Choice',
    component: 'HeaterChoice',
    nextId: `result-${heater}`,
  },
  {
    id: branch120,
    step: 'Heater Type',
    component: 'Selector',
    title: 'Would you prefer an electric tankless or MiniTank option?',
    tip: '<b>Note</b>: Hot water from 120V is only satisfactory for very low flow/low demand handwashing applications i.e. outdoor small kitchens, barns, workshops, RV’s, pleasure boats, & food trucks. When hot water demand is greater than handwashing, the heat provided is very limited.',
    options: [
      {
        title: 'Tankless',
        params: {
          'product-family': ['e15fa1b4-927d-44d8-a001-dd5d6c132c7f'],
          SKUs: ['SPEX3512T'],
          application: ['standard-hand-sink'],
        },
        value: 'Tankless',
        nextId: `result-${tankless}`,
      },
      {
        title: 'MiniTank',
        params: {
          'product-family': ['9424c736-316d-451c-a2a8-2d9c8f653194'],
        },
        value: 'MiniTank',
        nextId: stepMiniTankChoise,
      },
    ],
  },
  {
    id: stepMiniTankChoise,
    step: 'MiniTank Choice',
    component: 'HeaterChoice',
    nextId: `result-${miniTank}`,
  },
  {
    id: `result-${miniTank}`,
    step: 'Result',
    component: 'Result',
    type: miniTank,
  },
  {
    id: `result-${tankless}`,
    step: 'Result',
    component: 'Result',
    type: tankless,
  },
  {
    id: branchSolar,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    tip: '<b>Note</b>: For Thermal solar backup use, there is no 120V heater that would suffice. It would have to be 240V preferably, or 208V',
    hint: 'Almost all residential homes will have 240 volts as a standard ‘high’ voltage.  This is the voltage that powers your electric tank-type hot water heater, electric range, electric clothes dryer, well pump, central air conditioning system, and other high-power devices in your home. However, there are some areas of the country (Metro New York City, for example) where 208 VAC is the standard ‘high’ voltage available. In addition, 208 VAC is sometimes found as the ‘high’ voltage in apartment buildings, condominiums, factory building loft conversions, and the like.  If you are unsure of your ‘high’ voltage in your residence, call an electrician, your local electrical utility, a building maintenance employee or building supervisor for more information',
    options: [
      {
        title: '208 V',
        params: {
          volts: 208,
          phase: 1,
          'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'],
        },
        value: '208 V',
        nextId: `${branchWholeHome}_${stepGoalTemp}`,
      },
      {
        title: '240 V',
        params: {
          volts: 240,
          'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'],
        },
        value: '240 V',
        nextId: `${branchWholeHome}_${stepGoalTemp}`,
      },
    ],
  },
  {
    id: branchAutoBuster,
    step: 'Result',
    component: 'Result',
    type: autoBuster,
    // @TODO get from API in component or from store based previous steps
    products: [
      {
        title: 'AutoBooster',
        img: `${process.env.VUE_APP_PATH}img/auto-buster.jpg`,
        quantity: 1,
      },
    ],
  },
  {
    id: branchSingleFixture,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    tip: '<b>Note</b>: For Household single point of use, 120V would not normally suffice due to its allowance limitations in heating normal household flow rates. 240V is preferable, or 208V, but there are 120V options.',
    hint: 'Almost all residential homes will have 240 volts as a standard ‘high’ voltage.  This is the voltage that powers your electric tank-type hot water heater, electric range, electric clothes dryer, well pump, central air conditioning system, and other high-power devices in your home. However, there are some areas of the country (Metro New York City, for example) where 208 VAC is the standard ‘high’ voltage available. In addition, 208 VAC is sometimes found as the ‘high’ voltage in apartment buildings, condominiums, factory building loft conversions, and the like.  If you are unsure of your ‘high’ voltage in your residence, call an electrician, your local electrical utility, a building maintenance employee or building supervisor for more information',
    options: [
      {
        title: '120 V',
        params: { volts: 120 },
        value: '120 V',
        hint: 'Hot water from 120V is only satisfactory for low flow/low demand handwashing applications i.e. outdoor kitchens, barns, workshops, RV’s, pleasure boats, & food trucks. When hot water demand is greater than handwashing, the heat provided is very limited.',
        nextId: branch120,
      },
      {
        title: '208 V',
        params: {
          volts: 208,
          phase: 1,
          'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'],
        },
        value: '208 V',
        nextId: `${branchSingleFixture}_${stepGoalTemp}`,
      },
      {
        title: '240 V',
        params: {
          volts: 240,
          'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'],
        },
        value: '240 V',
        nextId: `${branchSingleFixture}_${stepGoalTemp}`,
      },
    ],
  },
  {
    id: `${branchSingleFixture}_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    tip: '<b>Note</b>: According to the Consumer Protection Safety Commission: Most adults can suffer 3rd-degree burns if exposed to 140°F water within 6 seconds. Burns can also occur within 30 seconds @ 130°F, & 5 minutes @ 120°F.',
    paramName: 'temp-out',
    nextId: `${branchSingleFixture}_${stepFlowRate}`,
  },
  {
    id: `${branchSingleFixture}_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRate',
    tip: '<b>Note</b>: When sizing for a single point of use unit, the unit should be as close as possible to the fixture it services, otherwise it will adversely affect the time to temperature delivery!!',
    paramName: 'flow-rate',
    nextId: `result-${heater}`,
  },
  {
    id: branchFaster,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    tip: '<b>Note</b>: For a Household single point of use booster, the voltage should be 240V preferably, or 208V, but there are limited 120V options.',
    hint: 'Almost all residential homes will have 240 volts as a standard ‘high’ voltage.  This is the voltage that powers your electric tank-type hot water heater, electric range, electric clothes dryer, well pump, central air conditioning system, and other high-power devices in your home. However, there are some areas of the country (Metro New York City, for example) where 208 VAC is the standard ‘high’ voltage available. In addition, 208 VAC is sometimes found as the ‘high’ voltage in apartment buildings, condominiums, factory building loft conversions, and the like.  If you are unsure of your ‘high’ voltage in your residence, call an electrician, your local electrical utility, a building maintenance employee or building supervisor for more information',
    options: [
      {
        title: '120 V',
        params: { volts: 120 },
        value: '120 V',
        nextId: branch120,
        hint: 'Hot water from 120V is only satisfactory for low flow/low demand handwashing applications i.e. outdoor kitchens, barns, workshops, RV’s, pleasure boats, & food trucks. When hot water demand is greater than handwashing, the heat provided is very limited.',
      },
      {
        title: '208 V',
        params: {
          volts: 208,
          phase: 1,
          'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'],
        },
        value: '208 V',
        nextId: `${branchFaster}_${stepGoalTemp}`,
      },
      {
        title: '240 V',
        params: {
          volts: 240,
          'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'],
        },
        value: '240 V',
        nextId: `${branchFaster}_${stepGoalTemp}`,
      },
    ],
  },
  {
    id: `${branchFaster}_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    tip: '<b>Note</b>: According to the Consumer Protection Safety Commission: Most adults can suffer 3rd-degree burns if exposed to 140°F water within 6 seconds. Burns can also occur within 30 seconds @ 130°F, & 5 minutes @ 120°F.',
    paramName: 'temp-out',
    nextId: `${branchFaster}_${stepFlowRate}`,
    enterIncoming: true,
  },
  {
    id: `${branchFaster}_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRate',
    tip: '<b>Note</b>: When sizing for a single point of use unit, the unit should be as close as possible to the fixture it services, otherwise it will adversely affect the time to temperature delivery!! Continue below to enter the flow rate of the one fixture that will be serviced',
    paramName: 'max-flow',
    nextId: `result-${heater}`,
  },
  {
    id: branchTwoFixture,
    step: 'Voltage',
    component: 'Selector',
    title: 'What is your choice of Single-Phase voltage for your heater?',
    tip: '<b>Note</b>: For Household multi-point of use, 120V would not suffice. It would have to be 240V preferably, or 208V',
    hint: 'Almost all residential homes will have 240 volts as a standard ‘high’ voltage.  This is the voltage that powers your electric tank-type hot water heater, electric range, electric clothes dryer, well pump, central air conditioning system, and other high-power devices in your home. However, there are some areas of the country (Metro New York City, for example) where 208 VAC is the standard ‘high’ voltage available. In addition, 208 VAC is sometimes found as the ‘high’ voltage in apartment buildings, condominiums, factory building loft conversions, and the like.  If you are unsure of your ‘high’ voltage in your residence, call an electrician, your local electrical utility, a building maintenance employee or building supervisor for more information',
    options: [
      {
        title: '208 V',
        params: {
          volts: 208,
          phase: 1,
          'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'],
        },
        value: '208 V',
        nextId: `${branchTwoFixture}_${stepGoalTemp}`,
      },
      {
        title: '240 V',
        params: {
          volts: 240,
          'product-family': ['f5ebdf5a-0521-42bf-9705-bca931fbab94'],
        },
        value: '240 V',
        nextId: `${branchTwoFixture}_${stepGoalTemp}`,
      },
    ],
  },
  {
    id: `${branchTwoFixture}_${stepGoalTemp}`,
    step: 'Goal Temperature',
    component: 'GoalTemperature',
    tip: '<b>Note</b>: According to the Consumer Protection Safety Commission: Most adults can suffer 3rd-degree burns if exposed to 140°F water within 6 seconds. Burns can also occur within 30 seconds @ 130°F, & 5 minutes @ 120°F.',
    paramName: 'temp-out',
    nextId: `${branchTwoFixture}_${stepFlowRate}`,
  },
  {
    id: `${branchTwoFixture}_${stepFlowRate}`,
    step: 'Flow Rate',
    component: 'FlowRateWithSelect',
    tip: '<b>Note</b>: When sizing for a point of use unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to get separate sizing for a separate unit if other fixture locations are further away (beyond 15’ – 20’). Continue below to select the local fixtures',
    paramName: 'max-flow',
    nextId: `result-${heater}`,
    title: 'Which fixtures would the unit be servicing?',
    text: 'IMPORTANT: The fixtures selected here should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    hint: 'You can manually overwrite your simultaneous flow rate to the right if your fixture flow rates differ from the selections above.',
    fixtures: [
      {
        title: 'Low Flow Handwash Sink',
        flowRate: '~0.5 - 1 GPM',
        flowRateValue: 1,
        img: `${process.env.VUE_APP_PATH}/img/LFHS.jpg`,
        quantity: 1,
      },
      {
        title: 'Standard Handwash Sink',
        flowRate: '~1.25 - 1.5 GPM',
        flowRateValue: 1.5,
        img: `${process.env.VUE_APP_PATH}/img/SHS.jpg`,
        quantity: 1,
      },
    ],
  },
  {
    id: `result-${heater}`,
    step: 'Result',
    component: 'Result',
    type: heater,
  },
  {
    id: needHelp,
    step: 'Need Help',
    component: 'NeedHelp',
  },
  {
    id: callUs,
    step: 'Call',
    component: 'Call',
  },
];
